import React from 'react';
import charities from '../charities.json';

export default function Charities() {
  return (
    <div className="charities-container">
      <h2>We Support These Charities</h2>
      <div className="charity-logos">
        {charities.map((charity) => (
          <a
            key={charity.name}
            href={charity.website}
            target="_blank"
            rel="noopener noreferrer"
            className="charity-link"
          >
            <img
              src={`/logos/${charity.logo}`}
              alt={charity.name}
              className="charity-logo"
            />
          </a>
        ))}
      </div>

      <style jsx>{`
        .charities-container {
          width: 100%;
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          padding: 1rem;
          box-sizing: border-box;
          text-align: center;
        }

        .charity-logos {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1.5rem;
          margin-top: 1rem;
        }

        .charity-logo {
          height: 60px;
          max-width: 150px;
          object-fit: contain;
          transition: transform 0.2s ease;
        }

        .charity-link:hover .charity-logo {
          transform: scale(1.05);
        }

        @media (max-width: 600px) {
          .charity-logo {
            height: 40px;
          }
        }
      `}</style>
    </div>
  );
}
